import apiClient from './client'

const ACCESS_KEY = 'token' // client.ts อ่าน key นี้ใส่ Authorization header
const REFRESH_KEY = 'refresh_token'

export interface LoginResponse {
  access: string
  refresh: string
}

// ตรงกับ RolePermissionView (backend/main/views.py) — สิทธิ์แยกจาก JWT payload
// ตั้งใจ เพราะสิทธิ์เปลี่ยนได้โดยไม่ต้อง login ใหม่
export interface RolePermission {
  username: string
  email: string
  // ใช้ซ่อน/โชว์เครื่องมือของผู้ดูแลระบบ — backend เช็คซ้ำอีกชั้นเสมอ
  is_superuser: boolean
  roles: string[]
  permissions: string[]
  all_stations: boolean
  station_ids: number[]
}

export async function login(username: string, password: string): Promise<void> {
  const { data } = await apiClient.post<LoginResponse>('/auth/token/', { username, password })
  localStorage.setItem(ACCESS_KEY, data.access)
  localStorage.setItem(REFRESH_KEY, data.refresh)
}

export function logout(): void {
  localStorage.removeItem(ACCESS_KEY)
  localStorage.removeItem(REFRESH_KEY)
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY)
}

// ต่ออายุ access token ด้วย refresh token — คืน true ถ้าสำเร็จ
export async function refreshAccessToken(): Promise<boolean> {
  const refresh = getRefreshToken()
  if (!refresh) return false
  try {
    const { data } = await apiClient.post<{ access: string }>('/auth/token/refresh/', { refresh })
    localStorage.setItem(ACCESS_KEY, data.access)
    return true
  } catch {
    logout()
    return false
  }
}

export async function fetchRolePermission(): Promise<RolePermission> {
  const { data } = await apiClient.get<RolePermission>('/auth/role-permission/')
  return data
}
